export default __webpack_public_path__ + "static/media/windows.0cd0408e.svg";